module.exports = __webpack_public_path__ + "img/limocar.acf0ecb1.webp";